import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { invoiceQueryOptions } from '../../../../features/sales/queries'

export const Route = createFileRoute('/_app/invoices/$invoiceId')({
  staticData: { crumb: 'invoice' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'sales.read'),
  loader: ({ context, params }) => context.queryClient.ensureQueryData(invoiceQueryOptions(params.invoiceId)),
  component: Outlet,
})
